<template>
  <div class="download">
    <banner img="../assets/img/appDown.jpg" title="下载资料" />
    <div class="table-container">
      <table class="download-table">
        <thead>
          <tr>
            <th>名称</th>
            <th>下载链接</th>
            <th>使用手册</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>电脑客户端下载</td>
            <td><a href="./static/client.EXE" class="download-button" download="工程管理平台.exe">下载客户端</a></td>
            <td><a href="./static/handbook.pdf" class="download-button" download="PC端基于BIM的智慧工程管理平台用户使用手册.pdf">下载使用手册</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import Bottom from "../components/Bottom"; 

export default {
  components: {
    Banner,
    Bottom
  }
};
</script>

<style lang="scss" scoped>
.download {
  text-align: center;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
}

.table-container {
  margin-top: 20px;
  flex: 1;
}

.download-table {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border-collapse: collapse;
}

.download-table th, .download-table td {
  border: 1px solid #ddd;
  padding: 12px;
}

.download-table th {
  background-color: #f2f2f2;
}

.download-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
}

.download-button:hover {
  background-color: #0056b3;
}

.bottom-container {
  margin-top: 40px;
  flex-shrink: 0;
}

body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>